
import './App.css';
import '@fontsource/roboto/500.css';

function Carousel() {
  return (
    <>
        <div id="myCarousel" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
              <li data-target="#myCarousel" data-slide-to="1"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
              <li data-target="#myCarousel" data-slide-to="3"></li>
              <li data-target="#myCarousel" data-slide-to="4"></li>
              <li data-target="#myCarousel" data-slide-to="5"></li>
              <li data-target="#myCarousel" data-slide-to="6"></li>
              <li data-target="#myCarousel" data-slide-to="7"></li>
              <li data-target="#myCarousel" data-slide-to="8"></li>
              <li data-target="#myCarousel" data-slide-to="9"></li>
              <li data-target="#myCarousel" data-slide-to="10"></li>                            
              
            </ol>
            <div class="carousel-inner">

              <div class="carousel-item active">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-dental.png" alt='Dental Service'  />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>              

              <div class="carousel-item">
                <img class="Second-slide img-fluid" src="../../../../assets/img/lc-banner-metro.jpg" alt='Metro Service' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <img class="Third-Slide img-fluid" src="../../../../assets/img/lc-banner-metro-1.jpg" alt='Metro Service 6 Men'  />
                <div class="container">
                  <div class="carousel-caption text-right">
                    
                  </div>
                </div>
              </div>

              <div class="carousel-item">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-diwali.jpg" alt='Diwali Service' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    {/* <p><a class="btn btn-lg btn-primary" href="#" role="button">Call Now</a></p> */}
                  </div>
                </div>
              </div>

              <div class="carousel-item">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-paint.jpg" alt='Painting Service'  />
                <div class="container">
                  <div class="carousel-caption text-left">
                    {/* <p><a class="btn btn-lg btn-primary" href="#" role="button">Call Now</a></p> */}
                  </div>
                </div>
              </div>              

              <div class="carousel-item">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-paint1.jpg"  alt='Painting Service Men at Work' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>                            

              <div class="carousel-item">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-sofa.jpg" alt='Sofa Service Shifting Work' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <img class="first-slide img-fluid" src="../../../../assets/img/lc-banner-school7.jpg" alt='School Service Men at Work' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>                        
              <div class="carousel-item">
                <img class="Second-slide img-fluid" src="../../../../assets/img/lc-banner-school8.jpg" alt='School Service Men at Work' />
                <div class="container">
                  <div class="carousel-caption text-left">
                    
                  </div>
                </div>
              </div>

              <div class="carousel-item">
                <img class="Fifth-Slide img-fluid" src="../../../../assets/img/lc-banner-house2.jpg" alt='House Service Men at Work' />
                <div class="container">
                  <div class="carousel-caption">
                    
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <img class="Sixth-Slide img-fluid" src="../../../../assets/img/lc-banner-house3.jpg" alt='House Service Men at Work' />
                <div class="container">
                  <div class="carousel-caption text-right">
                    
                  </div>
                </div>
              </div>

              {/* <div class="carousel-item">
                <img class="Third-Slide img-fluid" src="../../../../assets/img/lc-banner-school1.jpg"  />
                <div class="container">
                  <div class="carousel-caption text-right">
                    <p><a class="btn btn-lg btn-primary" href="#" role="button">Call Now</a></p>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <img class="Third-Slide img-fluid" src="../../../../assets/img/lc-banner-school2.jpg"  />
                <div class="container">
                  <div class="carousel-caption text-right">                  
                    <p><a class="btn btn-lg btn-primary" href="#" role="button">Call Now</a></p>
                  </div>
                </div>
              </div>               */}          

              {/* <div class="carousel-item">
                <img class="Fourth-Slide img-fluid" src="../../../../assets/img/lc-banner-house1.jpg"  />
                <div class="container">
                  <div class="carousel-caption text-right">
                    <p><a class="btn btn-lg btn-primary" href="#" role="button">Call Now</a></p>
                  </div>
                </div>
              </div>                            */}
            
            </div>
              <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
          </div>     
    </>
  );
}

export default Carousel;


